<template>
  <v-container class="DesignFileType">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large>mdi-newspaper</v-icon>{{ $t('article.article')}}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"

          :to="{ name: 'ArticleList' }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          v-if="userHasAccess('article_edit')"
          class="ml-2"
          color="primary"
          :to="{ name: 'ArticleUpdate' }"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row class="ml-0 mr-0">
        <v-col md="4">
          <ImageView :item="item" filter="400x400" :edit="userHasAccess('article_edit')"  />
          <router-link :to="{ name: 'ArticleShowLink', params: { id: item['@id'] }}">{{ $t('global.linkshare')}}</router-link>
        </v-col>
        <v-col md="8" >
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('article.title') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['name'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('article.titlefr') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['namefr'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.date') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ formatDate(item['date']) }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.file') }}</span>
                </v-col>
                <v-col md="9">
                  <v-btn
                                         v-if="item['file']"
                                         color="secondary"
                                         class=""
                                         @click="downloadFileByObject(item)"
                                       >
                                         {{ $t('global.download') }}
                                         <v-icon
                                           right
                                           dark
                                         >mdi-download
                                         </v-icon>
                                       </v-btn>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('article.link') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['link'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('article.linkfr') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['linkfr'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('article.enabled') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">
                    <span v-if="item.enabled" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                    <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
                  </strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" >
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.hub') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">
                    <span v-if="item.public" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                    <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
                  </strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import ImageView from '../../components/ImageView.vue';

const servicePrefix = 'Article';

export default {
  name: 'ArticleShow',
  servicePrefix,
  components: {
      Loading,
      ImageView
  },
  data: () => ({
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('article', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('article', ['find']),

  },
  methods: {
    ...mapActions('article', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
